import type { FC, MouseEvent } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TSearchInput } from './models';

export const SearchInput: FC<TSearchInput> = ({
    IconButton,
    IconCross,
    IconSearch,
    Input,
    Label,
    autoComplete = 'on',
    className,
    innerRef,
    onClose,
    onSubmit,
    styles,
    value,
    ...inputProps
}) => (
    <form className={styles.contentsForm} onSubmit={onSubmit}>
        <Label
            className={className}
            leftPlace={
                <IconButton aria-label="запустить поиск" tabIndex={-1} type="submit">
                    <IconSearch
                        className={cn(styles.iconSearch, styles.external)}
                        height={18}
                        width={18}
                    />
                </IconButton>
            }
            rightPlace={
                onClose && value?.toString().length ? (
                    <IconButton
                        aria-label="очистить поиск"
                        className={cn(styles.crossButton, styles.external)}
                        onClick={onClose}
                        onMouseDown={(event: MouseEvent) => event.preventDefault()}
                        type="button"
                    >
                        <IconCross className={cn(styles.inputCross, styles.external)} />
                    </IconButton>
                ) : null
            }
        >
            <Input
                autoComplete={autoComplete}
                hideSearchCross={Boolean(onClose)}
                innerRef={innerRef}
                name="search"
                type="search"
                value={value}
                {...inputProps}
            />
        </Label>
    </form>
);
